<template>
  <div class="received-log-box">
    <div class="received-log-box__received-at-area">
      <div class="received-log-box__received-at">
        {{ formattedReceivedDate }}
      </div>
    </div>

    <div class="received-log-box__contents" @click="moveReceivedGift">
      <div class="contents__header">
        <AccountIconWh24 :image-url="senderIconImageUrl" />
        <div class="contents__caption-area">
          <div class="contents__caption caption-bold">
            <a
              class="contents__sender-name"
              :class="
                showUsableProfileLink
                  ? 'contents__sender-name--link'
                  : 'contents__sender-name--no-link'
              "
              :href="showUsableProfileLink ? createdUserProfilePath : null"
            >
              {{ senderName }}
            </a>
          </div>
          <div class="contents__caption-suffix">
            さんからギフトを受け取りました
          </div>
        </div>
      </div>
      <div class="contents__body">
        <div class="contents__card-design-image-url">
          <ImgLazy
            :image-url="cardDesignImageUrl"
            alt-text="カードデザイン画像URL"
            aspect-ratio="1"
            width="56"
            height="56"
          />
        </div>
        <div class="contents__message-area message--min">
          <div class="contents__message">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import AccountIconWh24 from '../../../atoms/account_icons/AccountIconWh24.vue'
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
export default {
  components: { AccountIconWh24, ImgLazy },
  props: {
    id: {
      type: Number,
      require: true,
      default: 0
    },
    senderName: {
      type: String,
      require: true,
      default: ''
    },
    senderIconImageUrl: {
      type: String,
      require: true,
      default: ''
    },
    message: {
      type: String,
      require: true,
      default: ''
    },
    receivedAt: {
      type: String,
      require: true,
      default: ''
    },
    cardDesignImageUrl: {
      type: String,
      require: true,
      default: ''
    },
    token: {
      type: String,
      require: true,
      default: ''
    },
    showUsableProfileLink: {
      type: Boolean,
      required: false,
      default: false
    },
    createdUserProfilePath: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    formattedReceivedDate() {
      return dayjs(this.receivedAt).format('YYYY年M月D日 HH:mm')
    }
  },
  methods: {
    moveReceivedGift() {
      location.href = `/r/${this.token}`
    }
  }
}
</script>

<style lang="scss" scoped>
.received-log-box {
  background-color: $gray-3;
  padding: 0 16px;
  max-width: $small-contents-width;
  margin: auto;

  &:last-child {
    padding-bottom: 24px;
  }

  &__received-at-area {
    margin: 0 auto;
  }

  &__received-at {
    padding: 24px 0 8px 0;
    color: $gray-1;
  }

  &__contents {
    margin: 0 auto;
    padding: 16px;
    background-color: $white;
    cursor: pointer;
    border-radius: 8px;

    .contents__header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }

    .contents__caption-area {
      display: flex;
      align-items: center;
      margin-left: 8px;
    }

    .contents__caption {
      color: $black;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;

      &-suffix {
        font-size: 1.2rem;
      }
    }

    .contents__sender-name {
      overflow: hidden;
      max-width: 100px;
      text-overflow: ellipsis;
      white-space: nowrap;

      &--link {
        color: $link;
      }

      &--no-link {
        color: $black;
        pointer-events: none;
      }
    }

    .contents__body {
      display: flex;
      align-items: center;
    }

    .contents__message-area {
      margin-left: 16px;
      padding: 12px;
      width: 100%;
    }

    .contents__message {
      height: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      overflow: hidden;
    }
  }
}
</style>
